import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../../menus/base.menu';
import { InspectionClipboardService } from '../../shared/services/inspection-clipboard.service';
import { InspectionService } from '../../shared/services';
import { InspectionDetailMenu } from '../../menus/inspection.menu';

@Component({
  templateUrl: './inspection-model.menu.html',
  standalone: false
})
export class InspectionModelMenuComponent extends BaseMenuComponent {
  inspection: any;
  currentPerson: any;
  items: any = InspectionDetailMenu;
  public anyModules = false;
  hideModules = false;
  checkSapPrices$: Observable<{ available: boolean }>;

  constructor(public modal: ModalComponent, public clipboard: InspectionClipboardService, private inspectionService: InspectionService) {
    super(modal);
    this.selectedGroup = 'general';
  }

  init(data: any) {
    this.inspection = data.inspection;
    this.currentPerson = data.currentPerson;
    this.anyModules = data.anyModules;
    this.hideModules = data.hideModules;
    this.checkSapPrices$ = this.inspectionService.checkSapPrices(this.inspection.id);
  }

  canSendToValidate() {
    return this.inspection.progression === 100;
  }

  public get isOptimization() {
    return this.inspection.applicationType === 1;
  }

  public get isMaintenance() {
    return this.inspection.applicationType === 0;
  }

  public get isInstallation() {
    return this.inspection.applicationType === 2;
  }

  public get isInOffline() {
    return this.inspection.isOffline;
  }

  public get isOfflinePerson() {
    return this.currentPerson.id === this.inspection.offlinePersonId;
  }

  public get onlyOnline() {
    return this.isConnection && !this.isInOffline;
  }

  public isPaste(): boolean {
    return this.clipboard.hasData(this.inspection);
  }
}
